import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin, Clock } from 'lucide-react';
const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const scrollToSection = (id: string) => {
    if (!isHomePage) {
      // If not on home page, navigate to home with hash
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // If no specific ID, scroll to top for "Home"
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-gray-800 text-white" data-id="element-117" data-mp="3qfjj8jyhljpp">
      <div className="container mx-auto px-4 py-12" data-id="element-118" data-mp="29yxdpewb9omv">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-119" data-mp="2a19uvpu8vuyv">
          {/* Company Info */}
          <div data-id="element-120" data-mp="2evxbz3mx5n3f">
            <h3 className="text-xl font-bold mb-4" data-id="element-121" data-mp="3l9abve5p2w2b">I75 Audio & Video, LLC</h3>
            <p className="text-gray-300 mb-6" data-id="element-122" data-mp="3lbdbmpwng3k8">
              Southwest Florida's premier provider of audio, video, and smart
              technology solutions for homes and businesses.
            </p>
            <div className="flex space-x-4" data-id="element-123" data-mp="3v5dhwv3o3euj">
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="Facebook" data-id="element-124" data-mp="3q7llbns2v4k0">
                <Facebook className="w-5 h-5" data-id="element-125" data-mp="34gwrh0rwr7l" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="Instagram" data-id="element-126" data-mp="31up7hdvubpd">
                <Instagram className="w-5 h-5" data-id="element-127" data-mp="cu8uul8302gt" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="Twitter" data-id="element-128" data-mp="qsqd43f7wmrc">
                <Twitter className="w-5 h-5" data-id="element-129" data-mp="tv4ng298r450" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-130" data-mp="two07ivoux21">
                <Linkedin className="w-5 h-5" data-id="element-131" data-mp="13s9980z6cxla" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-132" data-mp="18lbttjlz4wpc">
            <h3 className="text-xl font-bold mb-4" data-id="element-133" data-mp="18ltzt7yfupag">Quick Links</h3>
            <ul className="space-y-2" data-id="element-134" data-mp="1ckt4crg9ck1d">
              <li data-id="element-135" data-mp="1cnytu7sstnxm">
                {isHomePage ? <button onClick={() => scrollToSection('top')} className="text-gray-300 hover:text-white transition-colors" data-id="element-136" data-mp="1hje12gwawll2">
                    Home
                  </button> : <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-137" data-mp="3obew7peob6aa">
                    Home
                  </Link>}
              </li>
              <li data-id="element-138" data-mp="2afx3f293sd71">
                {isHomePage ? <button onClick={() => scrollToSection('about-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-139" data-mp="25oexs0w4xofq">
                    About Us
                  </button> : <Link to="/#about-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-140" data-mp="1wlm985ec7qtl">
                    About Us
                  </Link>}
              </li>
              <li data-id="element-141" data-mp="2kci5beptt86n">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-142" data-mp="2kf4gdobxe5tm">
                    Services
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-143" data-mp="13xqdb2wle2xv">
                    Services
                  </Link>}
              </li>
              <li data-id="element-144" data-mp="2ivud8xu4qxcw">
                {isHomePage ? <button onClick={() => scrollToSection('gallery-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-145" data-mp="2isyhng5r8krm">
                    Projects
                  </button> : <Link to="/#gallery-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-146" data-mp="3fks9kkhj33c6">
                    Projects
                  </Link>}
              </li>
              <li data-id="element-147" data-mp="1q5uihrtcf0nr">
                {isHomePage ? <button onClick={() => scrollToSection('testimonials-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-148" data-mp="1q52m4erx8ywf">
                    Testimonials
                  </button> : <Link to="/#testimonials-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-149" data-mp="1imctw018rkkc">
                    Testimonials
                  </Link>}
              </li>
              <li data-id="element-150" data-mp="13xglu2z6q7jq">
                {isHomePage ? <button onClick={() => scrollToSection('contact-form')} className="text-gray-300 hover:text-white transition-colors" data-id="element-151" data-mp="13vvvyqntfcs7">
                    Contact
                  </button> : <Link to="/#contact-form" className="text-gray-300 hover:text-white transition-colors" data-id="element-152" data-mp="18w9tvfvpd6ci">
                    Contact
                  </Link>}
              </li>
              <li data-id="element-153" data-mp="2gawzvu5i0282">
                <button onClick={() => alert('Privacy Policy information would appear here.')} className="text-gray-300 hover:text-white transition-colors" data-id="element-154" data-mp="2gbf69jlvjwtp">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-155" data-mp="1xc17mod79xwv">
            <h3 className="text-xl font-bold mb-4" data-id="element-156" data-mp="1xckriameuwdj">Our Services</h3>
            <ul className="space-y-2" data-id="element-157" data-mp="22aumak483uym">
              <li data-id="element-158" data-mp="22bxa2j691hab">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-159" data-mp="22cp5ntzujf0l">
                    Home Theater Installation
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-160" data-mp="3irgobf76x7wp">
                    Home Theater Installation
                  </Link>}
              </li>
              <li data-id="element-161" data-mp="172kb3mhe3jd9">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-162" data-mp="12aiop7qicc9i">
                    Commercial Audio Systems
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-163" data-mp="ne1isw137puc">
                    Commercial Audio Systems
                  </Link>}
              </li>
              <li data-id="element-164" data-mp="efg2z8n02ox9">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-165" data-mp="2dp5ynp36qepy">
                    Camera & Monitoring
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-166" data-mp="1ml4u7ek0o7gu">
                    Camera & Monitoring
                  </Link>}
              </li>
              <li data-id="element-167" data-mp="yvaij0bfooy6">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-168" data-mp="ytpln41nctx5">
                    WiFi & Networking
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-169" data-mp="twz5kgpudybq">
                    WiFi & Networking
                  </Link>}
              </li>
              <li data-id="element-170" data-mp="cmlqkedjvr4i">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-171" data-mp="cn51hb4s9f91">
                    Smart Home Programming
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-172" data-mp="hkdmdjhbfxdz">
                    Smart Home Programming
                  </Link>}
              </li>
              <li data-id="element-173" data-mp="15bsnxa19qao6">
                {isHomePage ? <button onClick={() => scrollToSection('services-section')} className="text-gray-300 hover:text-white transition-colors" data-id="element-174" data-mp="1596lfot8ilct">
                    Video Distribution
                  </button> : <Link to="/#services-section" className="text-gray-300 hover:text-white transition-colors" data-id="element-175" data-mp="325vws0lcd8nf">
                    Video Distribution
                  </Link>}
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-176" data-mp="3x7rghoxjdv7">
            <h3 className="text-xl font-bold mb-4" data-id="element-177" data-mp="3xrbc3y54cbv">Contact Us</h3>
            <ul className="space-y-4" data-id="element-178" data-mp="3zc6nvsa3zas">
              <li className="flex" data-id="element-179" data-mp="11kzu3r6rb7a6">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-180" data-mp="11jyct4z5dok0" />
                <span data-id="element-181" data-mp="wmohj8p2uio9">
                  <a href="tel:2392038333" className="hover:text-blue-300 transition-colors" data-id="element-182" data-mp="wm59qkt55any">
                    (239) 203-8333
                  </a>
                </span>
              </li>
              <li className="flex" data-id="element-183" data-mp="1kay0m2uwosbp">
                <Mail className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-184" data-mp="1kbzl0xxtar63" />
                <span data-id="element-185" data-mp="1fkr8vu53krp8">
                  <a href="mailto:info@i75av.com" className="hover:text-blue-300 transition-colors" data-id="element-186" data-mp="1fjg7g0z4jw1a">
                    info@i75av.com
                  </a>
                </span>
              </li>
              <li className="flex" data-id="element-187" data-mp="1wttk3wny1r5c">
                <MapPin className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-188" data-mp="1wss91s6xh4nm" />
                <span data-id="element-189" data-mp="21sws9pz80dhj">Cape Coral, Florida</span>
              </li>
              <li className="flex" data-id="element-190" data-mp="21u7uhld0pd6j">
                <Clock className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-191" data-mp="26s9cs42md8gy" />
                <span data-id="element-192" data-mp="26rraappd5y0l">
                  Mon-Fri: 8am - 6pm
                  <br data-id="element-193" data-mp="2astcnfekuq6s" />
                  Sat: 10am - 4pm
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 text-center" data-id="element-194" data-mp="2fmebf9nzvo71">
          <p className="text-gray-400" data-id="element-195" data-mp="2ki34cu5ie6ud">
            © {new Date().getFullYear()} I75 Audio & Video, LLC. All rights
            reserved. Licensed and Insured in the State of Florida.
          </p>
          <p className="text-gray-400 mt-2" data-id="element-196" data-mp="2uidh6dnmtc90">
            FL License #ES12002457 | NY License #12000310349
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;